// ** React Imports
import { useState, useEffect } from 'react'
import axios from 'axios'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import React from 'react'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import Button from '@mui/material/Button'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import Card from '@mui/material/Card';
import { ToastContainer, toast } from 'react-toastify';
// import { Grid, Typography } from '@mui/material'
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteIcon from '@mui/icons-material/Delete'
import { useNavigate } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import "../Button.css"
import { confirmAlert } from 'react-confirm-alert' // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { Controller, useForm } from "react-hook-form";
import ReactSelect from "react-select";

import {
  Modal,
  Typography,
  TextField,
  Divider,
  NativeSelect,
  Autocomplete,
  Grid,
  Paper
} from "@mui/material";
import { TabPanel, TabContext, TabList } from "@mui/lab";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AgendaRegistration from '../AgendaRegistration'
import Headroom from "react-headroom";
import DialogTitle from '@mui/material/DialogTitle';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import moment from 'moment'
import jsPDF from 'jspdf';
import 'jspdf-autotable';



const Agendas = () => {
  document.title = "Agendas | Maevisory";

  const [isLoading, setLoading] = useState(false)
  const getRowSpacing = React.useCallback(params => {
    return {
      top: params.isFirstVisible ? 0 : 0.5,
      bottom: params.isLastVisible ? 0 : 0.8
    }
  }, [])
  const token = localStorage.getItem('Token')
  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }
  const gridStyle = {
    color: '#8392ab !important',
    textTransform: 'lowercase',
    fontSize: '13.6px',
    fontWeight: '400',
    '&:hover': {
      color: 'rgba(5, 152, 236, 0.637) !important',
      fontSize: '14.6px'
    }
  }

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    background: 'drak',
    fontSize: '13.4px !important',
    color: 'drak !important',
    borderColor: '#326C1D',
    '& .MuiDataGrid-cell:hover': {
      color: 'rgba(5, 152, 236, 0.637) !important',
      fontSize: '14.6px !important',
    },
    '& .super-app-theme--header': {
      backgroundColor: '#377562',
      borderRadius: 0.1,
      color: 'white',
      fontSize: '16px !important',

    },

  }

  const gridClasses = {
    columnHeader: 'MuiDataGrid-columnHeaders',
  };
  const [refresh, setRefresh] = useState(false)
  function applyRefresh() {
    setRefresh(!refresh)
  }

  const navigate = useNavigate();
  const [Agnedid, setAgnedid] = useState('')
  const [Agned, setAgned] = React.useState(false);
  const handleAgned = () => {
    setAgned(true)
  };
  const handlecloseAgned = () => {
    setAgnedid('')
    // setLomnRequestid('')
    //  setPatientNamee('')
    setAgned(false)
  };
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      cellClassName: 'gridCell',
      sortable: false,
      flex: 0.13,
    },
    {
      field: 'taskPerformed',
      headerClassName: 'super-app-theme--header',
      headerName: 'Task Performed',
      cellClassName: 'gridCell',
      flex: 0.28,
      renderCell: cellValues => (
        <Button
          style={{ display: "flex", justifyContent: "flex-start" }}
          size='small'
          variant='text'
          color='info'
          onClick={(event) => {
            // openUserRegistration(event,cellValues.row.id )
            setAgnedid(cellValues.row.id)

          }}
        >{`${cellValues.row.taskPerformed}`}</Button>
      )
    },
    // {
    //   field: 'taskPerformed',
    //   headerClassName: 'super-app-theme--header',
    //   headerName: 'Task Performed',
    //   flex: 0.5
    // },
    {
      field: 'therapistsName',
      headerClassName: 'super-app-theme--header',
      headerName: 'Supervisee Name',
      flex: 0.27
    },
    {
      field: 'discussionIC',
      headerClassName: 'super-app-theme--header',
      headerName: 'Discussion IC',
      flex: 0.2
    },
    {
      field: 'userContent',
      headerClassName: 'super-app-theme--header',
      headerName: 'User Content',
      flex: 0.2
    },
    // {
    //   field: 'time',
    //   headerClassName: 'super-app-theme--header',
    //   headerName: 'Time',
    //   flex: 0.16
    // },
    {
      field: 'dateTime',
      headerClassName: 'super-app-theme--header',
      headerName: 'Date',
      flex: 0.19
    },
    {
      field: 'approvedBy',
      headerClassName: 'super-app-theme--header',
      headerName: 'Approved By',
      flex: 0.2
    },

    {
      field: 'approvedDateTime',
      headerClassName: 'super-app-theme--header',
      headerName: 'Approved Date',
      flex: 0.28,
    },
    {
      field: 'inActive',
      headerClassName: 'super-app-theme--header',
      headerName: 'Delete',
      sortable: true,
      flex: 0.14,
      renderCell: cell => (
        <DeleteIcon
          style={{
            marginRight: '5px',
            float: 'right',
            marginTop: '5px',
            color: 'red',
            cursor: 'pointer'
          }}
          onClick={cellValues => {
            confirmAlert({
              message: 'Do you want to delete the record.',
              closeOnEscape: true,
              closeOnClickOutside: true,
              overlayClassName: 'overlay-custom-class-name',
              buttons: [
                {
                  label: 'Yes',
                  onClick: () => {
                    const postData = {

                      inActive: true,
                      id: cell.row.id
                    }

                    axios
                      .post(`${process.env.REACT_APP_API_URL}/UserNotes/AddUserNote`, postData, {
                        headers
                      })
                      .then(response => {
                        setRefresh(!refresh)
                        // setOpenNote(false)
                        // console.log('response.data: ', response.data)
                      })
                      .catch(error => {
                        console.error('There was an error!', error)
                      })
                  }
                },
                {
                  label: 'No'
                }
              ]
            })
          }}
        ></DeleteIcon>
      )
    }



  ]
  useEffect(() => {
    if (Agnedid > 0) {
      handleAgned()
    }
  }, [Agnedid]);
  const [selectedValue, setSelectedValue] = useState('')
  const handleChange = event => {
    const newValue = event.target.value
    setSelectedValue(newValue)
    applyRefresh(newValue)
    console.log("Selected value my kya ha : ", newValue)
  }
  const [rows, setRows] = useState(null)
  const [seletedTherpist, setseletedTherpist] = useState(0);
  const [TherapistName, setTherapistName] = useState('');
  const [TherapistFilter, setTherapistFilter] = useState(false);
  const Userid = localStorage.getItem('userid')

  const onFilterSearch = event => {
    if (userType === 'Supervisor' || userType === "Admin") {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/UserNotes/getUserNotes?requestString=${selectedValue}&TherapistId=${seletedTherpist ? seletedTherpist :''}`,
          { headers }
        )
        .then(response => {
          console.log('response.data: ', response)
          setRows(response)
          setData(response)
        })
        .catch(error => {
          console.error('There was an error!', error)
        })
      } else {
        axios
        .get(
          `${process.env.REACT_APP_API_URL}/UserNotes/getUserNotes?requestString=${selectedValue}&TherapistId=${Userid}`,
          { headers }
        )
        .then(response => {
          setRows(response)
          setData(response)
        })
        .catch(error => {
          console.error('There was an error!', error)
        })
  
      }

  }
  const [Data, setData] = useState([])
  useEffect(() => {
    if (userType == 'Therapist') {
      setLoading(true)

    axios
      .get(`${process.env.REACT_APP_API_URL}/UserNotes/getUserNotes?requestString=${selectedValue}&Therpistid=${Userid}`, { headers })
      .then(response => {
        setLoading(false)
        setRows(response)
        setData(response)
      })
      .catch(error => { })
    }

  }, [refresh, selectedValue])
  useEffect(() => {
    if (userType !== 'Therapist') {
      setLoading(true)
    axios
      .get(`${process.env.REACT_APP_API_URL}/UserNotes/getUserNotes?requestString=${selectedValue}`, { headers })
      .then(response => {
        setLoading(false)
        setRows(response)
        setData(response)
      })
      .catch(error => { })
    }
  }, [refresh, selectedValue])

  const openUserRegistration = (event, id = 0) => {
    navigate('/AgendaRegistration', { state: { uid: id } })
  }

  const style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 500,
    height: 400,
    bgcolor: 'white',
    border: '2px solid #EA7772',
    boxShadow: 24,
    // overflow: 'hidden',
    // p: 4,
    borderRadius: '8px',


  }

  const handleDownload = async () => {
    const doc = new jsPDF();
  
    const margin = 10;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
  
    const drawFirstPageHeader = () => {
      const title = 'Agendas Report';
      doc.setFontSize(19);
      doc.setTextColor(0, 102, 204);
      doc.setFont('helvetica', 'bold');
  
      const titleX = (pageWidth - doc.getTextWidth(title)) / 2;
      let yPosition = 20;
      doc.text(title, titleX, yPosition);
  
      yPosition += 15;
  
      if (TherapistFilter === true) {
        const reportText = `${TherapistName}'s Report`;
        doc.setFontSize(14);
        doc.setTextColor(0, 0, 0);
  
        // Centering the report text
        const reportTextX = (pageWidth - doc.getTextWidth(reportText)) / 2;
        doc.text(reportText, reportTextX, yPosition); // Use the calculated x-position
        yPosition += 10;
      }
  
      doc.setTextColor(0, 0, 0);
      doc.setFont('helvetica', 'normal');
      return yPosition;
    };
  
    const drawBorder = () => {
      doc.setDrawColor(0, 0, 0);
      doc.rect(margin, margin, pageWidth - margin * 2, pageHeight - margin * 2);
    };
  
    const startY = drawFirstPageHeader();
    drawBorder();
  
    const columns = [
      { header: 'ID', dataKey: 'id' },
      { header: 'Supervisee Name', dataKey: 'therapistsName' },
      { header: 'User Content', dataKey: 'userContent' },
      { header: 'Date Time', dataKey: 'dateTime' },
      { header: 'Start Time', dataKey: 'startTime' },
      { header: 'End Time', dataKey: 'endTime' },
    ];
  
    const rows = Data.map(item => ({
      id: item.id,
      therapistsName: item.therapistsName,
      userContent: item.userContent,
      dateTime: item.dateTime,
      startTime: item.startTime,
      endTime: item.endTime,
    }));
  
    doc.autoTable({
      head: [columns.map(col => col.header)],
      body: rows.map(item => Object.values(item)),
      startY: startY,
      margin: { top: margin + 5, bottom: margin + 5 },
  
      didDrawPage: (data) => {
        drawBorder(); // Draw the border on each page
      },
    });
  
    const fileName = `Agendas_✍${moment(new Date()).format('DD_MMM_YY')}.pdf`;
  
    doc.save(fileName);
  };
  
  
  


  const [TherapistList, setTherapistList] = useState([]);
  const { control, setValue, getValues } = useForm();


  const userType = localStorage.getItem('User_Type');

  useEffect(() => {
    if (userType =='Admin'){
      axios
      .get(`${process.env.REACT_APP_API_URL}/Users/getUsers?userType=${'Therapist'}`, {
          headers
        })
        .then(response => {
          var prac = [];
          response.forEach(field => {
            prac.push({
              label: field.fullName,
              value: field.id
            });
          });
          setTherapistList(prac);
        })
        .catch(error => { });
    } else{

      axios
        .get(`${process.env.REACT_APP_API_URL}/SupervisorTherapist/GetThrepistListBySupervisorId?supervisorId=${Userid}`, {
          headers
        })
        .then(response => {
          var prac = [];
          response.forEach(field => {
            prac.push({
              label: field.fullName,
              value: field.id
            });
          });
          setTherapistList(prac);
        })
        .catch(error => { });
    }
  }, []);
  const onSeacrhButtonClick = event => {
    setLoading(true)
    setTherapistFilter(true)

    axios
      .get(
        `${process.env.REACT_APP_API_URL}/UserNotes/getUserNotes?requestString=${selectedValue}&Therpistid=${seletedTherpist ? seletedTherpist :''}`,
        { headers }
      )
      .then(response => {
        console.log('response.data: ', response)
        setData(response)
        setRows(response)
        setLoading(false)
      })
      .catch(error => {
        console.error('There was an error!', error)
      })
   

  }
  return (
    <>
      <Modal
        open={Agned}
        onClose={handlecloseAgned}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        visible={true} title={'Title'}
      >
        <Box sx={style}>
          <Headroom >
            <Grid
              container
              style={{ backgroundColor: '#356F60', position: 'sticky' }}
            >
              <Grid item xs={12} sm={12} xl={12}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'left',
                    justifyContent: 'space-between',
                    height: '2rem'
                  }}
                >
                  <DialogTitle
                    style={{
                      flex: 1,
                      // textAlign: 'left',
                    }}
                  >
                    <h1
                      style={{
                        fontWeight: 'bold',
                        // textAlign: 'left',
                        marginTop: '-10px',
                        color: '#fff',
                        textDecoration: 'underline',
                        fontSize: '1rem'

                      }}
                    >
                      Agenda Registration

                    </h1>
                  </DialogTitle>
                  <CancelOutlinedIcon
                    onClick={handlecloseAgned}
                    fontSize="large"
                    color="red"
                    style={{
                      color: 'red',
                      paddingRight: '5px',
                      cursor: 'pointer',
                      float: 'right'
                      // marginLeft: 'auto',
                      // marginRight: '1.5rem'
                    }}
                  ></CancelOutlinedIcon>
                </div>
              </Grid>
            </Grid>
          </Headroom>




          <Grid item xs={12} sm={12} xl={12} >
            <Card bordered={false} style={{
              overflow: 'auto',
              /* Other styles */
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: '#356F60 transparent', // thumb color and track color
              '&::-webkit-scrollbar': {
                width: 8, /* Width of vertical scrollbar */
                height: 8, /* Height of horizontal scrollbar */
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#356F60', /* Color of the thumb */
                borderRadius: 10,
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: 'transparent', /* Color of the track */
              },
              /* Adjust the width for the horizontal scrollbar */
              '&::-webkit-scrollbar-thumb:horizontal': {
                width: 4, /* Width of horizontal scrollbar */
              },
              // zIndex: "10",


              height: '80vh'
            }} >
              <AgendaRegistration UID={Agnedid} handleClose={handlecloseAgned}  >

              </AgendaRegistration>

            </Card>
            <ToastContainer
              position="bottom-center"
              autoClose={1500}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"

            />
          </Grid>


        </Box>
      </Modal>

      <div className="page-content">
        <Container>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Paper
                elevation={4}
                style={{
                  padding: '20px',
                  backgroundColor: '#f5f5f5',
                  borderRadius: '8px',
                  marginBottom: '16px',
                  width: '100%',
                  margin: '10px auto',
                  border: '2px solid #326C1D',
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={1}>
                    <Typography
                      style={{
                        color: 'black',
                        fontSize: '18px',
                        marginTop: '6px',
                        fontWeight: 'bold', // Make bold
                      }}
                    >
                      Type:
                    </Typography>
                  </Grid>

                  <Grid item xs={4}>
                    <NativeSelect
                      onChange={handleChange}
                      value={selectedValue}
                      style={{
                        width: '100%',
                        height: '40px',
                        padding: '5px 10px',
                        fontFamily: 'Inter',
                        fontSize: '16px',
                        fontWeight: '400',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        outline: 'none',
                        appearance: 'none',
                        backgroundColor: 'white',
                      }}
                    >
                      <option value="all">All</option>
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                    </NativeSelect>
                  </Grid>

                  {userType === 'Supervisor' || userType === 'Admin' ? (
                    <>
                      <Grid item xs={1.3}>
                        <Typography
                          style={{
                            color: '#333',
                            fontSize: '18px',
                            marginTop: '6px',
                            fontWeight: 'bold',
                            width: '90px',
                          }}
                        >
                          Supervisee:
                        </Typography>
                      </Grid>

                      <Grid item xs={4}>
                        <ReactSelect
                          options={TherapistList}
                          value={TherapistList.find(
                            (option) => option.value === getValues('therapistsId')
                          )}
                          onChange={(selectedOption) => {
                            setValue('therapistsId', selectedOption.value);
                            setseletedTherpist(selectedOption.value);
                            setTherapistName(selectedOption.label)

                            // onTherapistSearch(selectedOption.value);
                          }}
                          styles={{
                            container: (base) => ({
                              ...base,
                              width: '100%',
                            }),
                            control: (base) => ({
                              ...base,
                              height: '40px',
                              padding: '0px 5px',
                              fontFamily: 'Inter',
                              fontSize: '16px',
                              fontWeight: '400',
                              borderRadius: '4px',
                              border: '1px solid #ccc',
                              backgroundColor: 'white',
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: '0px',
                            }),
                            placeholder: (base) => ({
                              ...base,
                              color: '#aaa',
                            }),
                          }}
                          placeholder="Select Supervisee"
                        />
                      </Grid>
                      <Grid item xs={1.5}>
                    <Button
                      className="Button"
                      onClick={onSeacrhButtonClick}
                      fullWidth
                      // disabled={onFilterSearch}
                      variant='contained' style={{
                        fontSize: '14px', fontWeight: 'bold',
                      }}
                      type="submit"
                    >
                      Search
                    </Button>
                  </Grid>
                    </>
                  ) : (
                    <Grid item xs={3}></Grid>
                  )}

                  <Grid container item xs={userType === 'Therapist'? 4 :12} justifyContent="flex-end" spacing={2}>
                    <Grid item>
                      <Button
                        className="Button"
                        onClick={handleDownload}
                        disabled={!Data || Data.length === 0}
                        variant="contained"
                        style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                        }}
                      >
                        Download
                        <DownloadForOfflineIcon />
                      </Button>
                    </Grid>

                    <Grid item>
                      <Button
                        className="Button"
                        onClick={onFilterSearch}
                        variant="contained"
                        style={{
                          fontSize: '14px',
                          fontWeight: 'bold',
                        }}
                      >
                        <CachedOutlinedIcon
                          fontSize="small"
                          style={{
                            color: 'white',
                            paddingRight: '4px',
                            paddingBottom: '2px',
                          }}
                        />
                        Refresh
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>





            <Grid item xs={12} sm={12} xl={12}>
              <Box mb={0} style={{ marginTop: 0 }}>
                {isLoading ? (
                  <div style={{ margin: '5rem', textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                ) : (
                  <div mb={0} style={{ height: 400, width: '100%' }}>
                    {rows === null || rows.length === 0 ? ("No Record Found") : (
                      <DataGrid
                        rows={rows}
                        classes={gridClasses}
                        rowHeight={20}
                        columns={columns}
                        getRowSpacing={getRowSpacing}
                        //checkboxSelection
                        fullWidth
                        sx={gridRowStyle}
                        pagination
                        autoPageSize
                      />
                    )}
                  </div>
                )}
              </Box>
            </Grid>
          </Grid>
          {/* <div style={{ width: 200, marginTop: '5px', marginBottom: '0px' }}>
               
              </div> */}

        </Container>
      </div>
    </>


  )
}

export default Agendas
